@file:OptIn(InternalResourceApi::class)

package mobile_wallet.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.core.ui.generated.resources/"

public val Res.string.core_ui_account_balance: StringResource by lazy {
      StringResource("string:core_ui_account_balance", "core_ui_account_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 55),
      ))
    }

public val Res.string.core_ui_account_number: StringResource by lazy {
      StringResource("string:core_ui_account_number", "core_ui_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175, 46),
      ))
    }

public val Res.string.core_ui_all: StringResource by lazy {
      StringResource("string:core_ui_all", "core_ui_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222, 23),
      ))
    }

public val Res.string.core_ui_cancel: StringResource by lazy {
      StringResource("string:core_ui_cancel", "core_ui_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246, 30),
      ))
    }

public val Res.string.core_ui_confirm_qr_amount_message: StringResource by lazy {
      StringResource("string:core_ui_confirm_qr_amount_message", "core_ui_confirm_qr_amount_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277, 221),
      ))
    }

public val Res.string.core_ui_confirm_qr_amount_title: StringResource by lazy {
      StringResource("string:core_ui_confirm_qr_amount_title", "core_ui_confirm_qr_amount_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 499, 71),
      ))
    }

public val Res.string.core_ui_credits: StringResource by lazy {
      StringResource("string:core_ui_credits", "core_ui_credits", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 571, 35),
      ))
    }

public val Res.string.core_ui_debits: StringResource by lazy {
      StringResource("string:core_ui_debits", "core_ui_debits", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 607, 30),
      ))
    }

public val Res.string.core_ui_different_bank_message: StringResource by lazy {
      StringResource("string:core_ui_different_bank_message", "core_ui_different_bank_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 334),
      ))
    }

public val Res.string.core_ui_different_bank_title: StringResource by lazy {
      StringResource("string:core_ui_different_bank_title", "core_ui_different_bank_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 973, 68),
      ))
    }

public val Res.string.core_ui_error_icon_description: StringResource by lazy {
      StringResource("string:core_ui_error_icon_description", "core_ui_error_icon_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1042, 46),
      ))
    }

public val Res.string.core_ui_error_msg_access_denied: StringResource by lazy {
      StringResource("string:core_ui_error_msg_access_denied", "core_ui_error_msg_access_denied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1089, 107),
      ))
    }

public val Res.string.core_ui_error_msg_bad_gateway: StringResource by lazy {
      StringResource("string:core_ui_error_msg_bad_gateway", "core_ui_error_msg_bad_gateway", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1197, 125),
      ))
    }

public val Res.string.core_ui_error_msg_conflict: StringResource by lazy {
      StringResource("string:core_ui_error_msg_conflict", "core_ui_error_msg_conflict", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1323, 134),
      ))
    }

public val Res.string.core_ui_error_msg_gateway_timeout: StringResource by lazy {
      StringResource("string:core_ui_error_msg_gateway_timeout", "core_ui_error_msg_gateway_timeout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1458, 113),
      ))
    }

public val Res.string.core_ui_error_msg_generic: StringResource by lazy {
      StringResource("string:core_ui_error_msg_generic", "core_ui_error_msg_generic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1572, 81),
      ))
    }

public val Res.string.core_ui_error_msg_invalid_request: StringResource by lazy {
      StringResource("string:core_ui_error_msg_invalid_request", "core_ui_error_msg_invalid_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1654, 125),
      ))
    }

public val Res.string.core_ui_error_msg_network: StringResource by lazy {
      StringResource("string:core_ui_error_msg_network", "core_ui_error_msg_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1780, 105),
      ))
    }

public val Res.string.core_ui_error_msg_not_found: StringResource by lazy {
      StringResource("string:core_ui_error_msg_not_found", "core_ui_error_msg_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1886, 87),
      ))
    }

public val Res.string.core_ui_error_msg_request_timeout: StringResource by lazy {
      StringResource("string:core_ui_error_msg_request_timeout", "core_ui_error_msg_request_timeout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1974, 97),
      ))
    }

public val Res.string.core_ui_error_msg_server_error: StringResource by lazy {
      StringResource("string:core_ui_error_msg_server_error", "core_ui_error_msg_server_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2072, 118),
      ))
    }

public val Res.string.core_ui_error_msg_service_unavailable: StringResource by lazy {
      StringResource("string:core_ui_error_msg_service_unavailable", "core_ui_error_msg_service_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2191, 129),
      ))
    }

public val Res.string.core_ui_error_msg_too_many_requests: StringResource by lazy {
      StringResource("string:core_ui_error_msg_too_many_requests", "core_ui_error_msg_too_many_requests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2321, 115),
      ))
    }

public val Res.string.core_ui_error_msg_unauthorized: StringResource by lazy {
      StringResource("string:core_ui_error_msg_unauthorized", "core_ui_error_msg_unauthorized", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2437, 98),
      ))
    }

public val Res.string.core_ui_error_msg_validation_error: StringResource by lazy {
      StringResource("string:core_ui_error_msg_validation_error", "core_ui_error_msg_validation_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2536, 118),
      ))
    }

public val Res.string.core_ui_error_occurred: StringResource by lazy {
      StringResource("string:core_ui_error_occurred", "core_ui_error_occurred", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2655, 50),
      ))
    }

public val Res.string.core_ui_error_title_access_denied: StringResource by lazy {
      StringResource("string:core_ui_error_title_access_denied", "core_ui_error_title_access_denied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2706, 61),
      ))
    }

public val Res.string.core_ui_error_title_bad_gateway: StringResource by lazy {
      StringResource("string:core_ui_error_title_bad_gateway", "core_ui_error_title_bad_gateway", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2768, 55),
      ))
    }

public val Res.string.core_ui_error_title_conflict: StringResource by lazy {
      StringResource("string:core_ui_error_title_conflict", "core_ui_error_title_conflict", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2824, 48),
      ))
    }

public val Res.string.core_ui_error_title_gateway_timeout: StringResource by lazy {
      StringResource("string:core_ui_error_title_gateway_timeout", "core_ui_error_title_gateway_timeout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2873, 63),
      ))
    }

public val Res.string.core_ui_error_title_generic: StringResource by lazy {
      StringResource("string:core_ui_error_title_generic", "core_ui_error_title_generic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2937, 43),
      ))
    }

public val Res.string.core_ui_error_title_invalid_request: StringResource by lazy {
      StringResource("string:core_ui_error_title_invalid_request", "core_ui_error_title_invalid_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2981, 63),
      ))
    }

public val Res.string.core_ui_error_title_network: StringResource by lazy {
      StringResource("string:core_ui_error_title_network", "core_ui_error_title_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3045, 55),
      ))
    }

public val Res.string.core_ui_error_title_not_found: StringResource by lazy {
      StringResource("string:core_ui_error_title_not_found", "core_ui_error_title_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3101, 49),
      ))
    }

public val Res.string.core_ui_error_title_request_error: StringResource by lazy {
      StringResource("string:core_ui_error_title_request_error", "core_ui_error_title_request_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3151, 61),
      ))
    }

public val Res.string.core_ui_error_title_request_timeout: StringResource by lazy {
      StringResource("string:core_ui_error_title_request_timeout", "core_ui_error_title_request_timeout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3213, 63),
      ))
    }

public val Res.string.core_ui_error_title_server_error: StringResource by lazy {
      StringResource("string:core_ui_error_title_server_error", "core_ui_error_title_server_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3277, 56),
      ))
    }

public val Res.string.core_ui_error_title_service_unavailable: StringResource by lazy {
      StringResource("string:core_ui_error_title_service_unavailable", "core_ui_error_title_service_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3334, 75),
      ))
    }

public val Res.string.core_ui_error_title_too_many_requests: StringResource by lazy {
      StringResource("string:core_ui_error_title_too_many_requests", "core_ui_error_title_too_many_requests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3410, 69),
      ))
    }

public val Res.string.core_ui_error_title_unauthorized: StringResource by lazy {
      StringResource("string:core_ui_error_title_unauthorized", "core_ui_error_title_unauthorized", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3480, 56),
      ))
    }

public val Res.string.core_ui_error_title_validation_error: StringResource by lazy {
      StringResource("string:core_ui_error_title_validation_error", "core_ui_error_title_validation_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3537, 68),
      ))
    }

public val Res.string.core_ui_filter_apply: StringResource by lazy {
      StringResource("string:core_ui_filter_apply", "core_ui_filter_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3606, 48),
      ))
    }

public val Res.string.core_ui_filter_by_account: StringResource by lazy {
      StringResource("string:core_ui_filter_by_account", "core_ui_filter_by_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3655, 61),
      ))
    }

public val Res.string.core_ui_filter_clear_all: StringResource by lazy {
      StringResource("string:core_ui_filter_clear_all", "core_ui_filter_clear_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3717, 44),
      ))
    }

public val Res.string.core_ui_filter_content_desc: StringResource by lazy {
      StringResource("string:core_ui_filter_content_desc", "core_ui_filter_content_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3762, 43),
      ))
    }

public val Res.string.core_ui_filter_title: StringResource by lazy {
      StringResource("string:core_ui_filter_title", "core_ui_filter_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3806, 56),
      ))
    }

public val Res.string.core_ui_filter_transaction_type: StringResource by lazy {
      StringResource("string:core_ui_filter_transaction_type", "core_ui_filter_transaction_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3863, 63),
      ))
    }

public val Res.string.core_ui_header_account: StringResource by lazy {
      StringResource("string:core_ui_header_account", "core_ui_header_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3927, 50),
      ))
    }

public val Res.string.core_ui_interbank_unavailable_message: StringResource by lazy {
      StringResource("string:core_ui_interbank_unavailable_message", "core_ui_interbank_unavailable_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3978, 325),
      ))
    }

public val Res.string.core_ui_interbank_unavailable_title: StringResource by lazy {
      StringResource("string:core_ui_interbank_unavailable_title", "core_ui_interbank_unavailable_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4304, 87),
      ))
    }

public val Res.string.core_ui_password_requirements: StringResource by lazy {
      StringResource("string:core_ui_password_requirements", "core_ui_password_requirements", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4392, 65),
      ))
    }

public val Res.string.core_ui_proceed_payment: StringResource by lazy {
      StringResource("string:core_ui_proceed_payment", "core_ui_proceed_payment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4458, 43),
      ))
    }

public val Res.string.core_ui_retry: StringResource by lazy {
      StringResource("string:core_ui_retry", "core_ui_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4502, 29),
      ))
    }

public val Res.string.core_ui_select_account: StringResource by lazy {
      StringResource("string:core_ui_select_account", "core_ui_select_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4532, 50),
      ))
    }

public val Res.string.core_ui_try_again: StringResource by lazy {
      StringResource("string:core_ui_try_again", "core_ui_try_again", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4583, 81),
      ))
    }

public val Res.string.core_ui_try_interbank: StringResource by lazy {
      StringResource("string:core_ui_try_interbank", "core_ui_try_interbank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4665, 61),
      ))
    }

public val Res.string.core_ui_understood: StringResource by lazy {
      StringResource("string:core_ui_understood", "core_ui_understood", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4727, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("core_ui_account_balance", Res.string.core_ui_account_balance)
  map.put("core_ui_account_number", Res.string.core_ui_account_number)
  map.put("core_ui_all", Res.string.core_ui_all)
  map.put("core_ui_cancel", Res.string.core_ui_cancel)
  map.put("core_ui_confirm_qr_amount_message", Res.string.core_ui_confirm_qr_amount_message)
  map.put("core_ui_confirm_qr_amount_title", Res.string.core_ui_confirm_qr_amount_title)
  map.put("core_ui_credits", Res.string.core_ui_credits)
  map.put("core_ui_debits", Res.string.core_ui_debits)
  map.put("core_ui_different_bank_message", Res.string.core_ui_different_bank_message)
  map.put("core_ui_different_bank_title", Res.string.core_ui_different_bank_title)
  map.put("core_ui_error_icon_description", Res.string.core_ui_error_icon_description)
  map.put("core_ui_error_msg_access_denied", Res.string.core_ui_error_msg_access_denied)
  map.put("core_ui_error_msg_bad_gateway", Res.string.core_ui_error_msg_bad_gateway)
  map.put("core_ui_error_msg_conflict", Res.string.core_ui_error_msg_conflict)
  map.put("core_ui_error_msg_gateway_timeout", Res.string.core_ui_error_msg_gateway_timeout)
  map.put("core_ui_error_msg_generic", Res.string.core_ui_error_msg_generic)
  map.put("core_ui_error_msg_invalid_request", Res.string.core_ui_error_msg_invalid_request)
  map.put("core_ui_error_msg_network", Res.string.core_ui_error_msg_network)
  map.put("core_ui_error_msg_not_found", Res.string.core_ui_error_msg_not_found)
  map.put("core_ui_error_msg_request_timeout", Res.string.core_ui_error_msg_request_timeout)
  map.put("core_ui_error_msg_server_error", Res.string.core_ui_error_msg_server_error)
  map.put("core_ui_error_msg_service_unavailable", Res.string.core_ui_error_msg_service_unavailable)
  map.put("core_ui_error_msg_too_many_requests", Res.string.core_ui_error_msg_too_many_requests)
  map.put("core_ui_error_msg_unauthorized", Res.string.core_ui_error_msg_unauthorized)
  map.put("core_ui_error_msg_validation_error", Res.string.core_ui_error_msg_validation_error)
  map.put("core_ui_error_occurred", Res.string.core_ui_error_occurred)
  map.put("core_ui_error_title_access_denied", Res.string.core_ui_error_title_access_denied)
  map.put("core_ui_error_title_bad_gateway", Res.string.core_ui_error_title_bad_gateway)
  map.put("core_ui_error_title_conflict", Res.string.core_ui_error_title_conflict)
  map.put("core_ui_error_title_gateway_timeout", Res.string.core_ui_error_title_gateway_timeout)
  map.put("core_ui_error_title_generic", Res.string.core_ui_error_title_generic)
  map.put("core_ui_error_title_invalid_request", Res.string.core_ui_error_title_invalid_request)
  map.put("core_ui_error_title_network", Res.string.core_ui_error_title_network)
  map.put("core_ui_error_title_not_found", Res.string.core_ui_error_title_not_found)
  map.put("core_ui_error_title_request_error", Res.string.core_ui_error_title_request_error)
  map.put("core_ui_error_title_request_timeout", Res.string.core_ui_error_title_request_timeout)
  map.put("core_ui_error_title_server_error", Res.string.core_ui_error_title_server_error)
  map.put("core_ui_error_title_service_unavailable", Res.string.core_ui_error_title_service_unavailable)
  map.put("core_ui_error_title_too_many_requests", Res.string.core_ui_error_title_too_many_requests)
  map.put("core_ui_error_title_unauthorized", Res.string.core_ui_error_title_unauthorized)
  map.put("core_ui_error_title_validation_error", Res.string.core_ui_error_title_validation_error)
  map.put("core_ui_filter_apply", Res.string.core_ui_filter_apply)
  map.put("core_ui_filter_by_account", Res.string.core_ui_filter_by_account)
  map.put("core_ui_filter_clear_all", Res.string.core_ui_filter_clear_all)
  map.put("core_ui_filter_content_desc", Res.string.core_ui_filter_content_desc)
  map.put("core_ui_filter_title", Res.string.core_ui_filter_title)
  map.put("core_ui_filter_transaction_type", Res.string.core_ui_filter_transaction_type)
  map.put("core_ui_header_account", Res.string.core_ui_header_account)
  map.put("core_ui_interbank_unavailable_message", Res.string.core_ui_interbank_unavailable_message)
  map.put("core_ui_interbank_unavailable_title", Res.string.core_ui_interbank_unavailable_title)
  map.put("core_ui_password_requirements", Res.string.core_ui_password_requirements)
  map.put("core_ui_proceed_payment", Res.string.core_ui_proceed_payment)
  map.put("core_ui_retry", Res.string.core_ui_retry)
  map.put("core_ui_select_account", Res.string.core_ui_select_account)
  map.put("core_ui_try_again", Res.string.core_ui_try_again)
  map.put("core_ui_try_interbank", Res.string.core_ui_try_interbank)
  map.put("core_ui_understood", Res.string.core_ui_understood)
}
